import { AbstractDTO } from './abstract';
import { IHomePageGroupLinks } from '@signature-it/ngx-generic/interfaces';


export class HomepageGroupLinksDTO extends AbstractDTO implements IHomePageGroupLinks {
    group_id: number;
    parent_group_id: number;
    group_pic: string;
    group_name: string;
    description: string;
    link: string;
    order: number;
    hidden: number;
    css_class: string;
    acl_definition: string;
    tag: string;
    children: Array<HomepageGroupLinksDTO>;

    constructor(attributes: Object) {
        super(attributes);
        this.group_id = attributes['group_id'];
        this.parent_group_id = attributes['parent_group_id'];
        this.group_pic = attributes['group_pic'];
        this.description = attributes['description'];
        this.group_name = attributes['group_name'];
        this.link = attributes['link'];
        this.order = attributes['order'];
        this.hidden = attributes['hidden'];
        this.css_class = attributes['css_class'];
        this.acl_definition = attributes['acl_definition'];
        this.tag = attributes['tag'];
        this.children = attributes['children'] ? HomepageGroupLinksDTO.createFromArray(attributes['children']) : [];
    }

}
